import { Injectable } from '@angular/core';

@Injectable()
export class TprecmService {
   /**
    * Application-wide grid configuration
    *
    * @memberof TprecmService
    */
   private readonly _gridConfig = {
      size: 10
   };
   get gridSize() {
      return this._gridConfig.size;
   }
   set gridSize(value: number) {
      if (value > 0) {
         this._gridConfig.size = value;
      } else {
         console.error('Cannot set the grid size less than 1.');
      }
   }
}
